// T-160 (v1.8.45, Session 40, 02.10.2026, Kundin-Mail 01.10.2026 "1. echter Gutschein via Stripe"): persönliche Nachricht auf dem
// Gutschein mit fester Höchstlänge und Zeichenzähler. Bisher erlaubte das Formular 300 Zeichen, das PDF-Feld "Nachricht" zeigte
// davon nur drei Zeilen (GS-2026-5NBX abgeschnitten). Gleiche Werte im Backend: Business.Gutschein.GutscheinNachricht (PricingTests).

export const MAX_NACHRICHT_ZEICHEN = 250;
export const MAX_NACHRICHT_ZEILEN = 3;

/** Begrenzt die Eingabe auf höchstens 3 Zeilen und 250 Zeichen (Zeilenumbruch zählt als Zeichen). */
export function begrenzeNachricht(text: string): string {
  const zeilen = text.replace(/\r\n/g, '\n').split('\n');
  const begrenzt = zeilen.length > MAX_NACHRICHT_ZEILEN ? zeilen.slice(0, MAX_NACHRICHT_ZEILEN).join('\n') : zeilen.join('\n');
  return begrenzt.length > MAX_NACHRICHT_ZEICHEN ? begrenzt.slice(0, MAX_NACHRICHT_ZEICHEN) : begrenzt;
}

/** Text des Zählers unter dem Eingabefeld, z. B. "120 von 250 Zeichen". */
export function nachrichtZaehler(text: string | null | undefined): string {
  const laenge = (text ?? '').replace(/\r\n/g, '\n').length;
  return `${laenge} von ${MAX_NACHRICHT_ZEICHEN} Zeichen`;
}

/** True, wenn ein gespeicherter (älterer) Text länger ist als erlaubt und vor dem Speichern gekürzt werden muss. */
export function nachrichtZuLang(text: string | null | undefined): boolean {
  const t = (text ?? '').replace(/\r\n/g, '\n');
  return t.length > MAX_NACHRICHT_ZEICHEN || t.split('\n').length > MAX_NACHRICHT_ZEILEN;
}
